<script setup lang="ts">
import { Color } from '@afinius/types/Color';
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | '3xl';
  color?: Color;
  rotate?: number;
  isRotated?: boolean;
  hasFadeAnimation?: boolean;
}

withDefaults(defineProps<Props>(), {
  size: 'md',
  color: Color.gray500,
  rotate: undefined,
});
</script>

<template>
  <span
    class="icon"
    :class="classNames({ size, isRotated, hasFadeAnimation })"
    :style="{
      color,
      transform: rotate !== undefined ? `rotate(${rotate}deg)` : undefined,
    }"
  >
    <slot />
  </span>
</template>

<style lang="scss" scoped>
@use './Icon.scss';
</style>
